import { CreateEvent } from "./CreateEvent.modal";
import { useEffect, useState } from "react";
import { EditEvent } from "./EditEvent.eventTime";
import { ViewEvent } from "./ViewEvent.eventTime";
import { Event } from "../../models/calendar/Event.model";
import { useEvents } from "../../contexts/calendar/EventsContext.context";
import { useModalEvent } from "../../contexts/calendar/ModalEventContext.context";
import { Modal } from "antd";

export const ModalEvento = () => {
    const { setOptions, options } = useModalEvent();
    const { events } = useEvents();
    const [currentEvent,setCurrentEvent] = useState<Event>(events.filter((e) => e.id === options.id)[0]);
    const cerrar = (isOpen:boolean) =>{
        if(isOpen)return;
        setOptions((prev)=>({
            ...prev,
            isopen:isOpen,
            numberOfWeek:0,
            day:0,
            month:0,
            year:0,
            id:'',
            isCreating:false,
            isEditing:false,
            isViewing:false
        }))
    }
    useEffect(() => {
        if(options.isEditing||options.isViewing){
          const event:Event = events.filter((e) => e.id === options.id)[0];
          setCurrentEvent(event);
        }
    }, [options.isEditing,options.isViewing,options.id,events]);

    if(options.isCreating){
      return (<Modal
          title="Crear Evento"
          closable={{ 'aria-label': 'Custom Close Button' }}
          open={options.isopen}
          onCancel={() => cerrar(false)}
          maskClosable={false}
          destroyOnHidden={true}
          footer={null}
        >
            <div className="mt-5">
                <CreateEvent 
                  day={options.day} 
                  month={options.month} 
                  year={options.year}/>
            </div>
        </Modal>);  
    }else if(options.isEditing){
      return (<Modal
        title="Editar Evento"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={options.isopen}
        onCancel={() => cerrar(false)}
        maskClosable={false}
        destroyOnHidden={true}
        footer={null}
      >
          <div style={{marginTop: 16}}>
                {currentEvent&&<EditEvent event={currentEvent}/>}
          </div>
      </Modal>);
    }else if(options.isViewing){
        return (<Modal
        title={currentEvent ? currentEvent.summary.charAt(0).toUpperCase() + currentEvent.summary.slice(1) : 'Detalle del Evento'}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={options.isopen}
        onCancel={() => cerrar(false)}
        maskClosable={false}
        footer={null}
      >
          <div style={{marginTop: 8}}>
            {currentEvent&&<ViewEvent event={currentEvent}/>}
          </div>
      </Modal>);
    }
    return null;
};